import React from 'react';

type StatusType =
  | 'available' | 'occupied' | 'reserved' | 'transferred' |'pending' | 'approved' | 'rejected' | 'completed' | 'scheduled'
  | 'paid' | 'overdue' | 'partial' | 'active' | 'inactive';

interface StatusBadgeProps {
  status: StatusType | string;
  size?: 'sm' | 'md';
}

const statusMap: Record<string, string> = {
  available: 'status-badge status-available',
  occupied: 'status-badge status-occupied',
  reserved: 'status-badge status-reserved',
  transferred: 'status-badge status-transferred',
  pending: 'status-badge status-pending',
  'under review': 'status-badge status-reserved',
  approved: 'status-badge status-approved',
  rejected: 'status-badge status-rejected',
  completed: 'status-badge status-completed',
  scheduled: 'status-badge status-scheduled',
  paid: 'status-badge status-paid',
  overdue: 'status-badge status-overdue',
  partial: 'status-badge status-partial',
  active: 'status-badge status-approved',
  inactive: 'status-badge status-occupied',
};

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const cls = statusMap[status.toLowerCase()] || 'status-badge status-occupied';
  return (
    <span className={`${cls} ${size === 'sm' ? 'text-[11px] px-2' : ''}`}>
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
}